"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/index.ts
var DEFAULT_TYPES = {
  js: {
    start: "/*!\n",
    lineWith: " * ",
    end: "\n */\n"
  },
  css: {
    start: "/*!\n",
    lineWith: " * ",
    end: "\n */\n"
  },
  html: {
    start: "<!--\n",
    lineWith: " * ",
    end: "\n-->\n"
  },
  raw: {
    start: "",
    lineWith: " ",
    end: ""
  }
};
var niceComments = function(inArray, inType) {
  var options = DEFAULT_TYPES[inType] || inType;
  var result = inArray.map(function(item) {
    return options.lineWith + item;
  });
  return options.start + result.join("\n") + options.end;
};
var index_default = niceComments;


exports.default = index_default;

module.exports = exports.default;
